import React from 'react';
import CompatibleProducts from '@hpstellar/pdp/CompatibleProducts'
import Link from '@hpstellar/core/Link';

import withPageComponents from '../../../page/components/with-page-components';

const compatibleProductsLink = ({
    compatiblePrinters,
    name = 'See Compatible Printers',
    href = '#compatibleProducts'
}) => {
    if (compatiblePrinters && compatiblePrinters.compatibleProducts) {
        return (
            <Link className={'compatible-products-link'} href={href}>{name}</Link>
        );
    }
    return null;
};

export const CompatibleProductsLink = withPageComponents(compatibleProductsLink, { components: ['compatiblePrinters'] });


const compatibleProducts = ({
    compatiblePrinters
}) => {
    if (compatiblePrinters && compatiblePrinters.compatibleProducts) {
        return (
            <section
                id='compatibleProducts'>
                <CompatibleProducts
                    items={compatiblePrinters.compatibleProducts}
                />
            </section>);
    }
    return null;
}

export default withPageComponents(compatibleProducts, { components: ['compatiblePrinters'] })
